import { render, staticRenderFns } from "./AddVisitPayment.vue?vue&type=template&id=5f9f4d5a&scoped=true"
import script from "./AddVisitPayment.vue?vue&type=script&lang=js"
export * from "./AddVisitPayment.vue?vue&type=script&lang=js"
import style0 from "./AddVisitPayment.vue?vue&type=style&index=0&id=5f9f4d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9f4d5a",
  null
  
)

export default component.exports